module.exports = __webpack_public_path__ + "static/hero-9f1fca1d3bbd4763b322b1d617f65e64.jpg";